module.exports = __webpack_public_path__ + "media/images/vector_admin01-1a7d8e60db51140b104df915db715a39.svg";